// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-picker-preview[data-v-bb513ee0]{background-color:var(--c13a6e9e)}", ""]);
// Exports
module.exports = exports;
